import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useAuth from "../hooks/useAuth";

function Home() {
  const navigate = useNavigate();
  const { user, customClaims, loading } = useAuth(); // Get user authentication state and claims

  useEffect(() => {
    if (!loading) {
      if (!user) {
        navigate("/login");
      } else if (customClaims?.isEditor) {
        navigate("/editorial");
      } else {
        navigate("/mystories");
      }
    }
  }, [user, customClaims, loading, navigate]);

  return null; // Nothing is rendered, just redirects
}

export default Home;
